import { Controller } from "@hotwired/stimulus"

// Handles terms acceptance for signup forms
// Enables/disables OAuth buttons and submit button based on checkbox state
export default class extends Controller {
  static targets = ["checkbox", "submitButton", "hiddenField"]

  connect() {
    // Find OAuth buttons within the same card (they use a different controller namespace)
    this.oauthButtons = this.element.querySelectorAll('.btn-oauth')
    // Set initial state
    this.toggle()
  }

  toggle() {
    const accepted = this.checkboxTarget.checked

    // Update submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !accepted
    }

    // Update hidden field for form submission
    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = accepted ? "1" : "0"
    }

    // Update OAuth buttons (both links and forms)
    this.oauthButtons.forEach(button => {
      if (accepted) {
        // Enable the button
        button.classList.remove('disabled')
        button.removeAttribute('aria-disabled')
        button.removeAttribute('tabindex')

        // For links with stored OAuth URL, restore the real href
        if (button.tagName === 'A' && button.dataset.oauthUrl) {
          button.href = button.dataset.oauthUrl
        }

        // For button_to forms, enable the submit button
        if (button.tagName === 'INPUT' || button.tagName === 'BUTTON') {
          button.disabled = false
        }
      } else {
        // Disable the button
        button.classList.add('disabled')
        button.setAttribute('aria-disabled', 'true')
        button.setAttribute('tabindex', '-1')

        // For links, store current href and use placeholder
        if (button.tagName === 'A') {
          if (!button.dataset.oauthUrl && button.href && !button.href.startsWith('javascript:')) {
            button.dataset.oauthUrl = button.href
          }
          button.href = 'javascript:void(0)'
        }

        // For button_to forms, disable the submit button
        if (button.tagName === 'INPUT' || button.tagName === 'BUTTON') {
          button.disabled = true
        }
      }
    })
  }

  // Prevent OAuth button clicks when terms not accepted
  preventUnacceptedClick(event) {
    if (!this.checkboxTarget.checked) {
      event.preventDefault()
      event.stopPropagation()
      // Optionally highlight the terms checkbox
      this.checkboxTarget.focus()
    }
  }
}
